import { Control, Controller } from 'react-hook-form'
import { formatJson } from 'utils/helpers'

type JSONInputTextProps = {
  name: string
  control: Control<any>
  label?: string
  required?: boolean
  placeholder?: string
  error?: string
  hintText?: string
  defaultValue?: string
  disabled?: boolean
}

const JSONInputText = ({
  name,
  label = 'Json',
  required = false,
  placeholder = 'Enter Your JSON here...',
  control,
  error,
  hintText,
  disabled = false,
}: JSONInputTextProps) => {
  const handleBeautify = (value: string, onChange: (value: string) => void) => {
    if (!value) {
      return onChange('')
    }

    const result = formatJson(value)

    if (!result.success) return

    onChange(result.value)
  }

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={name}
          className="mb-2 block text-xs font-semibold text-sidebar-primary"
        >
          {label}
          {required && <span className="text-error">*</span>}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        rules={{ required }}
        render={({ field }) => (
          <>
            <div
              className={`${
                error ? 'border-error' : 'border-gray-300'
              } relative rounded-lg
                border `}
            >
              <textarea
                {...field}
                id={name}
                disabled={disabled}
                onChange={(e) => field.onChange(e.target.value)}
                onBlur={(e) => handleBeautify(e.target.value, field.onChange)}
                placeholder={placeholder}
                className={`min-h-32 w-full appearance-none rounded-lg border-none p-3 text-sm text-primary focus:outline-none disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-600`}
              ></textarea>
              <button
                onClick={() => handleBeautify(field.value, field.onChange)}
                type="button"
                disabled={disabled}
                className="absolute right-3 top-3 rounded bg-gray-200 px-3 py-1 text-sm font-bold text-gray-500 transition-all duration-300 hover:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-50"
              >
                Beautify
              </button>
            </div>
          </>
        )}
      />
      {/* Error & Hint Text */}
      {(error || hintText) && (
        <div>
          {error ? (
            <p className="mt-1 text-xs text-error">{error}</p>
          ) : (
            <p className="mt-1 px-3 text-[11px] text-gray-500">{hintText}</p>
          )}
        </div>
      )}
    </div>
  )
}

export default JSONInputText
